<template>
    <v-container fluid>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back()">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <v-row class="esign-detail-grid">
        <v-col cols="12" lg="5">
          <material-card color="primary" title="Detail Log Aktivitas" class="card-wrapper">
            <dl class="esign-dl">
              <div><dt>Waktu aktivitas</dt><dd>{{ formData.WaktuAktivitas || '-' }}</dd></div>
              <div><dt>Jenis aktivitas</dt><dd><esign-status-tag v-if="formData.JenisAktivitas" tone="info" :value="formData.JenisAktivitas" /><span v-else>-</span></dd></div>
              <div><dt>Username</dt><dd>{{ formData.Username || '-' }}</dd></div>
              <div><dt>Peran</dt><dd>{{ formData.Peran || '-' }}</dd></div>
              <div><dt>Nama tabel</dt><dd><code class="la-code">{{ formData.NamaTabel || '-' }}</code></dd></div>
              <div><dt>IP address</dt><dd>{{ formData.IPAddress || '-' }}</dd></div>
              <div><dt>User agent</dt><dd class="la-agent">{{ formData.UserAgent || '-' }}</dd></div>
            </dl>
          </material-card>
        </v-col>
        <v-col cols="12" lg="7">
          <material-card color="primary" title="Perubahan Data" class="card-wrapper">
            <div class="la-diff">
              <section class="la-diff__side">
                <h3 class="la-diff__title"><span class="la-dot la-dot--before"></span>Sebelum</h3>
                <pre v-if="pretty(formData.NilaiAktivitasSebelum)" class="la-diff__value">{{ pretty(formData.NilaiAktivitasSebelum) }}</pre>
                <p v-else class="la-diff__empty">Tidak ada data</p>
              </section>
              <section class="la-diff__side">
                <h3 class="la-diff__title"><span class="la-dot la-dot--after"></span>Sesudah</h3>
                <pre v-if="pretty(formData.NilaiAktivitasSesudah)" class="la-diff__value">{{ pretty(formData.NilaiAktivitasSesudah) }}</pre>
                <p v-else class="la-diff__empty">Tidak ada data</p>
              </section>
            </div>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  import moment from "moment";
  
  export default {
    data: () => ({
      dateFormat: "DD-MM-YYYY HH:mm:ss",
      formData: {
          Username: "",
          Peran: "",
          WaktuAktivitas: "",
          JenisAktivitas: "",
          NilaiAktivitasSebelum: "",
          NilaiAktivitasSesudah: "",
          NamaTabel: "",
          UserAgent: "",
          IPAddress: "",
        }
    }),
    created() {
      console.log("loading")
      this.getData();
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.id)
        apiServer
          .get("/log_aktivitas/detail/" + this.$route.params.id)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data;
            this.formData.WaktuAktivitas = moment.utc(this.formData.WaktuAktivitas).locale("id").format(this.dateFormat)
            console.log(this.formData)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      back() {
        this.$router.push('/log-aktivitas')
      },
      // JSON values are indented for reading; anything else is shown as is
      pretty(value) {
        if (value === null || value === undefined || value === '') return ''
        if (typeof value !== 'string') return JSON.stringify(value, null, 2)
        try {
          const parsed = JSON.parse(value)
          return typeof parsed === 'object' && parsed !== null ? JSON.stringify(parsed, null, 2) : value
        } catch (e) {
          return value
        }
      }
    }
  }
</script>
  

<style scoped>
/* style.css forces h3 / p sizes with !important, so text rules here do too */
.la-code {
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--esign-surface-muted);
  color: var(--esign-text);
  font-size: 13px;
}

.la-agent {
  font-size: 13px !important;
  color: var(--esign-text-muted) !important;
}

.la-diff {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.la-diff__side {
  min-width: 0;
}

.la-diff__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 8px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  color: var(--esign-text);
}

.la-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.la-dot--before {
  background: var(--esign-text-subtle);
}

.la-dot--after {
  background: var(--esign-primary);
}

.la-diff__value {
  max-height: 480px;
  margin: 0;
  padding: 12px 14px;
  overflow: auto;
  border: 1px solid var(--esign-border);
  border-radius: var(--esign-radius-sm);
  background: var(--esign-surface-muted);
  color: var(--esign-text);
  font-size: 12.5px;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.la-diff__empty {
  margin: 0 !important;
  padding: 16px;
  border: 1px dashed var(--esign-border-strong);
  border-radius: var(--esign-radius-sm);
  font-size: 13px !important;
  color: var(--esign-text-subtle);
  text-align: center;
}

@media (max-width: 760px) {
  .la-diff {
    grid-template-columns: 1fr;
  }
}
</style>
